export class ClientLibrarySearchFilters {
  public status: string[];
  public form_group: string[];
  public title: string[];
  public author: string[];
  public publication_date: string[];
  public assigned_provider: string[];
  public shared_with_patient: string[];

  constructor(data: any) {
    this.form_group = data.form_group ? [...data.form_group] : [];
    this.title = data.title ? [...data.title] : [];
    this.author = data.author ? [...data.author] : [];
    this.publication_date = data.publication_date ? [...data.publication_date] : [];
    this.assigned_provider = data.assigned_provider ? [...data.assigned_provider] : [];
    this.shared_with_patient = data.shared_with_patient ? [...data.shared_with_patient] : [];
    this.status = data.status ? [...data.status] : [];
  }

  public get existingParams() {
    const filled = Object.keys(this).reduce((result, key) => {
      const _acc = result;
      if (
        (!Array.isArray(this[key]) && this[key] !== null) ||
        (Array.isArray(this[key]) && this[key].length)
      ) {
        _acc[key] = this[key];
      }
      return _acc;
    }, {});
    return filled;
  }

  public changeCurrentFilters(field: string, id: number, value: boolean) {
    const fieldId = `${id}`;
    const array = this[field];

    if (!array) return;

    const index = array.indexOf(fieldId);

    if (index === -1 && value) {
      array.push(fieldId);
      return;
    }

    if (index !== -1 && !value) {
      array.splice(index, 1);
      return;
    }
  }

  public get length(): number {
    return Object.keys(this.existingParams).length;
  }
}
